export enum UviEventSendingProcessType {
  LETTER = 'LETTER',
  RS_APP = 'RS_APP'
}
